import { useSelector } from 'react-redux';

import LoyaltyTransactionRow from './LoyaltyTransactionRow';

const LoyaltyTransactionList = () => {
  const loyaltyTransactionReducer = useSelector(
    (state) => state.loyaltyTransaction
  );

  const { query, data } = loyaltyTransactionReducer;

  if (query.length === 0) {
    return null;
  }
  return (
    <>
      {query.map((loyaltyTransactionId) => (
        <LoyaltyTransactionRow
          key={loyaltyTransactionId}
          loyaltyTransaction={data[loyaltyTransactionId]}
        />
      ))}
    </>
  );
};

export default LoyaltyTransactionList;
